export function wrapActionModel (data) {
    if (data.action_type === 'story' || data.action_type === 'template' || data.action_type === 'templates') {
        return wrap10to11Story(data);
    }
    return data;
}

function wrap10to11Story (data) {
    if (data.version || data.version === '1.0') {
        return data;
    }
    let matcherTypeConvert = [
        { type: 'text', callback: convertText },
        { type: 'title', callback: convertTitle },
        { type: 'legend', callback: convertLegend },
        { type: 'image', callback: convertImage },
        { type: 'carousel', callback: convertCarousel },
        { type: 'video', callback: convertVideo },
        { type: 'video_icon', callback: convertVideoIcon },
        { type: 'sound', callback: convertSound },
        { type: 'sound_icon', callback: convertSoundIcon }
    ];
    let newData = {
        listItem: [],
        templateType: data.data.templateType
    };
    let foundItem;

    function convertText (data) {
        return {
            data: [
                { insert: data.data + '\n' }
            ],
            type: 'complex_text'
        };
    }

    function convertTitle (data) {
        return {
            data: [
                { insert: data.data },
                { attributes: { align: 'center', header: 1 }, insert: '\n' }
            ],
            type: 'complex_text'
        };
    }

    function convertLegend (data) {
        return {
            data: [
                { insert: data.data },
                { attributes: { align: 'right', header: 6 }, insert: '\n' }
            ],
            type: 'complex_text'
        };
    }

    function convertImage (data) {
        return {
            type: 'complex_image',
            data: {
                imageClickable: false,
                imageClickableText: '',
                imageLegend: false,
                imageWidth100: false,
                imageLegendText: '',
                imagesName: ['Undefined'],
                imagesPath: data.data,
                modeCarousel: false
            }
        };
    }

    function convertCarousel (data) {
        return {
            type: 'complex_image',
            data: {
                modeCarousel: true,
                imageClickable: false,
                imageWidth100: false,
                imageLegend: false,
                imagesName: Array(data.data.length).fill('Undefined'),
                imagesPath: data.data,
                imageClickableText: '',
                imageLegendText: ''
            }
        };
    }

    function convertVideo (data) {
        return {
            type: 'complex_video',
            data: {
                enableText: false,
                text: '',
                mode: 'landscape',
                url: data.data
            }
        };
    }

    function convertVideoIcon (data) {
        return {
            type: 'complex_video',
            data: {
                enableText: true,
                mode: 'landscape',
                text: data.data.text.data,
                url: data.data.url.data
            }
        };
    }

    function convertSound (data) {
        return {
            type: 'complex_sound',
            data: {
                enableText: false,
                soundName: data.data.name,
                soundPath: data.data.data,
                text: ''
            }
        };
    }

    function convertSoundIcon (data) {
        return {
            type: 'complex_sound',
            data: {
                enableText: true,
                soundName: data.data.data.name,
                soundPath: data.data.data.data,
                text: data.data.text.data
            }
        };
    }

    data.action_type = 'story';
    data.data.listItem.forEach((element) => {
        foundItem = matcherTypeConvert.find(function (matcherElement) {
            return matcherElement.type === element.type;
        });
        if (foundItem) {
            newData.listItem.push(foundItem.callback(element));
        } else {
            newData.listItem.push(element);
        }
    });

    data.data = newData;
    return data;
}
